export class ProviderKeys{
    static readonly JoyID: string = "joyid";
    static readonly PortalWallet: string = "portal-wallet";
}